import { emptyReceiverCriteria, IReceiverCriteria } from '../../model/receiver-criteria';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ReceiverService } from "../../services/receiver.service";
import { IReceiverList, emptyReceiverList } from "../../model/receiver-list";

@Component({
  selector: 'app-pub-searcher',
  templateUrl: './pub-searcher.component.html',
  styleUrls: ['./pub-searcher.component.css']
})
export class PubSearcherComponent implements OnInit {

  /**
   * Criterio de busqueda de receivers
   */
  receiverCriteria: IReceiverCriteria = emptyReceiverCriteria;

  /**
   * List of receivers
   */
  receiverList: IReceiverList = emptyReceiverList;

  /**
   * Variable que indica que se ha realizado una búsqueda
   */
  searchDireClick: boolean = false;

  /**
   *
   * @type {EventEmitter<any>}
   */
  @Output() onSearchEvent = new EventEmitter();

  /**
   * Indica si se debe mostrar o no el enlace para cargar mas resultados
   * Cuando el numero tota del resultados es superior al limite de la busqueda permitido
   */
  renderShowMoreResults: boolean = false;

  /**
   * Variable que almacena el resultado de la búsqueda
   */
  searchText: string = '';

  /**
   * Constructor
   * @param receiverService
   */
  constructor(
    private receiverService: ReceiverService
  ) {
    this.receiverCriteria.filter = 'company';
  }

  ngOnInit() {
  }

  /**
   * Metodo que realiza la busqueda de receivers con el filtro seleccionado
   */
  search() {
    this.searchDireClick = true;
    this.onSearchEvent.emit(this.searchDireClick);
    this.receiverService.getReceivers(this.receiverCriteria)
      .subscribe(result => {
        this.receiverList = result;
        this.searchText = String(this.receiverCriteria.value);
        this.renderShowMoreResults = this.hasMoreResults();
      });
  }

  /**
   * Permite eliminar los resultados de búsqueda
   */
  removeElements() {
    this.searchDireClick = false;
    this.onSearchEvent.emit(this.searchDireClick);
    this.receiverList = emptyReceiverList;
  }

  /**
   * Mostrar mas resultados
   */
  showMoreResults() {
    this.receiverCriteria.page = this.receiverCriteria.page + 1;
    this.receiverService.getReceivers(this.receiverCriteria)
      .subscribe(result => {
        this.receiverList = result;
        this.renderShowMoreResults = this.hasMoreResults();
      });
  }

  /**
   * Devuelve true o false indicando si hay mas resultados a mostrar
   */
  private hasMoreResults(): boolean {
    return this.receiverList.total > (this.receiverList.page * this.receiverList.limit);
  }
}



// WEBPACK FOOTER //
// ./src/app/app-public/pub-searcher/pub-searcher.component.ts